import {Projet} from '@/models';

export default [
	{
		path: '/projets',
		name: 'projets',
		meta: {
			title: 'Liste des projets',
			granted: [ 'API_GET_CLIENT' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Projet.vue')
	},
	{
		path: '/projets/show/:id',
		name: 'projet-show',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Projet/Show.vue'),
				class: Projet
			}),
			editRoute: { name: 'projet-edit' },
		},
		meta: {
			title: 'Détail d\'un projet',
			granted: [ 'API_GET_CLIENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
	{
		path: '/projets/edit/:id',
		name: 'projet-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Projet/Edit.vue'),
				class: Projet
			}),
		},
		meta: {
			title: 'Edition d\'un projet',
			granted: [ 'API_PUT_CLIENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];